<template>
<div class="error-component error-cant-reach-server alert alert-warning text-center">
    มีข้อผิดพลาดเกิดขึ้น: {{text}} ({{errorData.code}})
    <template v-if="!disableCTA">
      <br/>
      <strong>กรุณา{{ctaText}}</strong>
    </template>
</div>
</template>

<script>
export default {
  methods: {
    invokeCTA () {
      this.$emit('clickCTA')
    }
  },
  props: {
    text: {
      type: String,
      default: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้'
    },
    ctaText: {
      type: String,
      default: 'ลองอีกครั้ง'
    },
    disableCTA: {
      type: Boolean,
      default: false
    },
    errorData: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
</style>
